import styled from 'styled-components';

import { hexToRGB } from '../styles';

export const LinkedinButtonContainer = styled.div`
  width: 300px;
  height: 40px;
  display: flex;
  flex-direction: row;
  background: ${({ bg }) => hexToRGB(bg, 0.8) || '#2a7bb6'};
  font-weight: 500;
  margin: 0px;
  padding: 1px;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

  &:hover {
    background: ${({ bg }) => hexToRGB(bg) || '#2a7bb6'};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25)
  }
`;
